import { render, staticRenderFns } from "./SalesJournalCard.vue?vue&type=template&id=3fde70ea"
import script from "./SalesJournalCard.vue?vue&type=script&lang=js"
export * from "./SalesJournalCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports